@if (searchService.isTyping() && resultsService.listings().length === 0) {
  <!-- Streaming loading state -->
  <div class="flex flex-col items-center gap-lg py-3xl text-grey-90">
    <div class="flex items-center gap-sm">
      <span
        class="h-2 w-2 animate-bounce rounded-full bg-navy-blue-90 [animation-delay:-0.3s]"
      ></span>
      <span
        class="h-2 w-2 animate-bounce rounded-full bg-navy-blue-90 [animation-delay:-0.15s]"
      ></span>
      <span class="h-2 w-2 animate-bounce rounded-full bg-navy-blue-90"></span>
    </div>
    <p class="text-center font-body text-sm font-medium leading-lg text-grey-100">
      Αναζήτηση ακινήτων σε
      <a href="https://bee-realestate.gr/" target="_blank" rel="noopener noreferrer"
        class="font-semibold text-grey-120 underline decoration-grey-60 underline-offset-2 hover:decoration-grey-120">Bee Real Estate</a>,
      <a href="https://goldenhome.gr/" target="_blank" rel="noopener noreferrer"
        class="font-semibold text-grey-120 underline decoration-grey-60 underline-offset-2 hover:decoration-grey-120">Golden Home</a>,
      <a href="https://marketplace.altamiraproperties.gr/" target="_blank" rel="noopener noreferrer"
        class="font-semibold text-grey-120 underline decoration-grey-60 underline-offset-2 hover:decoration-grey-120">Altamira</a>
      και
      <a href="https://www.remax-choice.gr/" target="_blank" rel="noopener noreferrer"
        class="font-semibold text-grey-120 underline decoration-grey-60 underline-offset-2 hover:decoration-grey-120">Remax Choice</a>
      σε πραγματικό χρόνο&hellip;
    </p>
  </div>
}

@if (resultsService.listings().length > 0) {
  <div class="flex flex-col gap-2xl">
    <!-- Grid -->
    <div class="grid grid-cols-1 gap-2xl md:grid-cols-2">
      @for (listing of resultsService.listings(); track $index) {
        <div class="h-[460px] overflow-hidden rounded-lg shadow-md">
          <app-property-card [listing]="listing" [listingIndex]="$index" />
        </div>
      }
    </div>

    @if (searchService.isTyping() || searchService.isLoadingMore()) {
      <div class="grid grid-cols-1 gap-2xl md:grid-cols-2">
        <!-- Skeleton card -->
        <div class="h-[460px] overflow-hidden rounded-lg shadow-md animate-pulse">
          <div class="flex h-full flex-col bg-white">
            <!-- Gallery placeholder -->
            <div class="h-[45%] bg-grey-40"></div>
            <!-- Info placeholder -->
            <div
              class="relative z-10 flex h-[55%] flex-col gap-3 rounded-t-3xl bg-white p-4 shadow-xl"
            >
              <!-- Realtor bar -->
              <div class="h-8 w-full rounded-xs bg-grey-40"></div>
              <!-- Price + type row -->
              <div class="flex items-center justify-between">
                <div class="h-5 w-2/5 rounded bg-grey-40"></div>
                <div class="h-5 w-1/4 rounded-full bg-grey-40"></div>
              </div>
              <!-- Address -->
              <div class="h-4 w-3/4 rounded bg-grey-40"></div>
              <!-- Subtitle details -->
              <div class="h-4 w-1/3 rounded bg-grey-40"></div>
              <!-- Feature chips -->
              <div class="flex gap-2">
                <div class="h-5 w-16 rounded-full bg-grey-40"></div>
                <div class="h-5 w-20 rounded-full bg-grey-40"></div>
                <div class="h-5 w-14 rounded-full bg-grey-40"></div>
              </div>
              <!-- Description lines -->
              <div class="flex flex-col gap-1">
                <div class="h-3 w-full rounded bg-grey-40"></div>
                <div class="h-3 w-5/6 rounded bg-grey-40"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (
    !searchService.isTyping() &&
    !searchService.isLoadingMore() &&
    !searchService.propertiesDepleted() &&
    !searchService.isCancelled()
  ) {
    <div class="mt-2xl flex justify-center">
      <app-ghost-button
        label="Περισσότερα αποτελέσματα"
        iconRight="icon_add_20px.svg"
        (buttonClicked)="searchService.requestMoreProperties()"
      />
    </div>
  }
}

@if (searchService.propertiesDepleted()) {
  <div class="mt-2xl flex flex-col items-center gap-sm py-2xl text-center">
    <p class="font-heading text-sm font-semibold leading-md text-grey-110">
      @if (resultsService.listings().length > 0) {
        Δεν υπάρχουν άλλα αποτελέσματα
      } @else {
        Δεν υπάρχουν αποτελέσματα
      }
    </p>
    <p class="font-body text-xs font-medium leading-sm text-grey-90">
      @if (resultsService.listings().length > 0) {
        Έχουν εμφανιστεί όλα τα διαθέσιμα ακίνητα για τα φίλτρα που επιλέξατε στους συγκεκριμένους
        μεσίτες.
      }
    </p>
  </div>
}
